import { AlertTost, CustomInput } from "#components";
import ImagesUrl from "#constants/images.js";
import usePost from "#hooks/usePost.js";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { forgotPasswordInitialValues } from "#validations/initialValues.js";
import { forgotPasswordValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const ForgotPassword = () => {
  const nav = useNavigate();
  const {
    mutateAsync: sendOtpMutateAsync,
    isLoading: isLoadingSendOtp,
    error: errorSendOtp,
  } = usePost(ENDPOINTS.FORGOT_PASSWORD, QUERY_KEYS.FORGOT_PASSWORD_QUERY_KEY);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: forgotPasswordInitialValues,
    validationSchema: forgotPasswordValidationSchema,
    onSubmit: async (values) => {
      const data = {
        email: values.email,
      };

      try {
        const response = await sendOtpMutateAsync(data);
        if (response.status === true) {
          AlertTost(response?.message, "success");
          resetForm();
          nav(WebRoutePath.VERIFY_OTP.path, { state: values.email });
        }
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });
  return (
    <div className="login-main">
      <div className="login-logo-main">
        <img src={ImagesUrl.loginBackground} alt="" />
      </div>
      <div
        className="login-form-main"
        data-aos="fade-right"
        data-aos-duration="1500"
      >
        <form onSubmit={handleSubmit} className="login-card-item">
          <div className="inner-content">
            <div className="text-center">
              <h1 className="">Forgot Password !</h1>
              <p> Please enter your email address for send otp</p>
            </div>

            <div className="form-main">
              <div className="form-inner-div">
                <CustomInput
                  label="Email"
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Email Address"
                  error={errors.email}
                  touched={touched.email}
                />
              </div>
            </div>
          </div>
          <button disabled={isLoadingSendOtp}>
            {isLoadingSendOtp ? (
              <ClipLoader size={17} color="#fff" />
            ) : (
              "Send Otp"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
